import './style.css';
import Map from 'ol/Map.js';
import TileLayer from 'ol/layer/Tile.js';
import View from 'ol/View.js';
import XYZ from 'ol/source/XYZ.js';
import {fromLonLat} from 'ol/proj.js';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import Style from 'ol/style/Style.js';
import Circle from 'ol/style/Circle.js';
import Fill from 'ol/style/Fill.js';
import Stroke from 'ol/style/Stroke.js';
import Vector from 'ol/source/Vector.js';
import VectorLayer from 'ol/layer/Vector.js';
import Overlay from 'ol/Overlay.js';
(function ($, Drupal, drupalSettings) {
  let url = '/json/maps'
  const nodeId = drupalSettings.path.currentPath.match(/^node\/(\d+)/);
  let singleNode = false
  let zoom = 12
  let center = fromLonLat([-73.97815704457938, 40.72696607112035])
  if (nodeId && nodeId[1] && nodeId[1] != "38097") {
    singleNode = true;
    url = url + '/' + nodeId[1];
    zoom = 16
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, false);
    xhr.send();
    
    if (xhr.status === 200) {
      let data = JSON.parse(xhr.responseText);
      if (data && data.length > 0) {
        center = fromLonLat([data[0].longitude, data[0].latitude]);
      }
    }
  }
  const map = new Map({
    target: 'map',
    layers: [
      new TileLayer({
        source: new XYZ({
          url:
            'https://tiles.arcgis.com/tiles/VXxCfMpXUKuFKFvE/arcgis/rest/services/Pfaffs_New_York_1860/MapServer/tile/{z}/{y}/{x}'
        }),
      }),
    ],
    view: new View({
      center: center,
      zoom: zoom,
    }),
  });
  const element = document.getElementById('popup');

  const popup = new Overlay({
    element: element,
    positioning: 'bottom-center',
    stopEvent: false,
  });
  map.addOverlay(popup);

  const legend = document.getElementById("map-legend");
  const legendItems = [
    { label: "Bar", color: "red" },
    { label: "Place of Business", color: "blue" },
    { label: "Residence", color: "yellow" },
    { label: "Theatre", color: "green" },
  ];
  if (!singleNode) {
    legendItems.forEach((item) => {
      const legendItem = createLegendItem(item.label, item.color);
      legend.appendChild(legendItem);
    });
  }

  function createLegendItem(label, color) {
    const item = document.createElement("div");
    item.classList.add("legend-item");
    item.innerHTML = `<span class="legend-symbol" style="background-color: ${color};"></span>${label}`;
    return item;
  }

  fetch(url)
  .then(response => response.json())
  .then(data => {
      // Iterate through the data and create icons on the map
      data.forEach(item => {
          var iconFeature = new Feature({
              geometry: new Point(fromLonLat([item.longitude, item.latitude])),
              name: item.name  // You can use this property to set a name for the icon
          });

          let color = 'yellow';
          switch(item.place) {
            case 'Bar':
              color = 'red';
              break;
            case 'Theatre':
              color = 'green';
              break;
            case 'Office':
              color = 'blue';
              break;
          }
          const iconStyle = new Style({
            image: new Circle({
                radius: 8,
                fill: new Fill({
                    color: color
                }),
                stroke: new Stroke({
                    color: 'black',
                    width: 2
                })
            })
          });
          iconFeature.setStyle(iconStyle);
          iconFeature.set('name', item.name);
          iconFeature.set('id', item.nid);

          // Create a vector layer for the icons
          var vectorSource = new Vector({
              features: [iconFeature]
          });

          var vectorLayer = new VectorLayer({
              source: vectorSource
          });

          // Add the vector layer to the map
          map.addLayer(vectorLayer);

          if (!singleNode) {
            map.on('click', function (event) {
              var feature = map.forEachFeatureAtPixel(event.pixel, function (feature) {
                  return feature;
              });

              if (feature) {
                  var coordinates = feature.getGeometry().getCoordinates();
                  var name = feature.get('name');

                  var content = '<p><a href="/node/'+feature.get('id')+'">' + name + '</a></p>';
                  popup.setPosition(coordinates);
                  element.innerHTML = content;
                  popup.setOffset([0, -25]);
              } else {
                  popup.setPosition(undefined);
              }
            });
          }
        });
  });
}(jQuery, Drupal, drupalSettings));
